import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import useSocket from "src/_common/hooks/useSocket";
import {
  CRYPTO_SECRET_KEY,
  INSIDERODEO_EVENT_STORAGE,
  URLS,
  SOCKET_URL,
  SOCKET_CHANNEL,
  SOCKET_TRANSPORTS
} from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { toast } from "react-toastify";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import clsx from "clsx";
import VideoModal from "../modal/videoModal";
import Sponsor from "src/components/common/Sponsor";
import ProgressBar from "src/components/common/ProgressBar";
import Cryptr from "cryptr";
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventPerformancePage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const eventAction = useAppEventAction();
  const userDetails = useAppUserDetailsSelector();
  const [loginReq, setLoginReq] = useState<number>(0);
  const { eventId } = useParams<{ eventId?: string }>();
  const e_id: number = parseInt(cryptr.decrypt(eventId || ''));
  const guestUserId = useAppGuestUserIdSelector();
  const [performanceList, setPerformanceList] = useState<Array<{
    id?: number;
    title?: string;
    sponsor?: { file_mime?: string; original?: string };
    avatar?: { id?: number; original?: string };
    rp_start_pick?: number;
    status?: number;
  }> | null>(null);
  const [selectedPerformance, setSelectedPerformance] = useState<{ id?: number } | null>(null);
  const [responseDetails, setResponseDetails] = useState<{
    settings?: { is_event_prize?: boolean; is_game_prize?: boolean };
    rodeo_event_game_info?: { enable_header?: number };
    status?: unknown;
  } | null>(null);
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const [url, setUrl] = useState<string>("");
  const [promoType, setPromoType] = useState<string>("");
  const [socketData, setSocketData] = useState<unknown>(null);
  const [progressPercent, setProgressPercent] = useState<number>(0);

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
    transports: SOCKET_TRANSPORTS,
    upgrade: true,        // Enable transport upgrades (polling -> websocket)
    rememberUpgrade: true, // Remember successful upgrades for faster reconnection
  });

  useEffect(() => {
    socket.connect();

    //Status Change Socket
    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: Record<string, unknown>) => {
      eventAction.pushGameStatusChangeSocketDataIntoGameList(changeEventStatus);
    });

    //Performance List Update
    socket.on(SOCKET_CHANNEL.SCAVENGER_PERFORMANCE, (_data: unknown) => {
      getPerformanceList();
    });

    //Status Message Change Socket
    socket.on(SOCKET_CHANNEL.START_STOP_RP_EVENT, (data: unknown) => {
      console.log({ data });
      setSocketData(data);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: Record<string, unknown> & { rodeo_event_id?: number }) => {
      if (changeEventStatus && changeEventStatus.rodeo_event_id && guestUserId) {
        //   console.log(changeEventStatus.rodeo_event_id)
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  const getPerformanceList = () => {
    const params: Record<string, unknown> = {
      rodeo_event_id: e_id,
    };
    if (!userDetails) {
      if (guestUserId) {
        params["guest_user_id"] = guestUserId;
      }
    }
    eventApi.callPerformanceList(
      params,
      (_message: string, resp: unknown) => {
        if (resp && typeof resp === "object") {
          const respData = resp as {
            performances?: Array<{
              id?: number;
              title?: string;
              sponsor?: { file_mime?: string; original?: string };
              avatar?: { id?: number; original?: string };
              rp_start_pick?: number;
              status?: number;
            }>;
            progress?: number;
            rodeo_event_dtls?: { login_required?: number };
            settings?: { is_event_prize?: boolean; is_game_prize?: boolean };
            rodeo_event_game_info?: { enable_header?: number };
            status?: unknown;
          };
          if (respData.performances && respData.performances.length != 1) {
            setPerformanceList(respData.performances);
            if (respData.progress !== undefined) {
              setProgressPercent(respData.progress);
            }
          } else if (respData.performances && respData.performances.length === 1) {
            changePage(respData.performances[0]);
          }
          // console.log(resp)
          setResponseDetails(respData);
          setLoginReq(respData.rodeo_event_dtls?.login_required || 0);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const goToGameListingPage = (e: React.MouseEvent<HTMLAnchorElement> | undefined, performance: { id?: number; sponsor?: { file_mime?: string; original?: string } }) => {
    e?.preventDefault();
    if (responseDetails && typeof responseDetails === "object") {
      const respData = responseDetails;
      if (respData.rodeo_event_game_info?.enable_header !== undefined) {
        eventAction.setSiteHeader(Boolean(respData.rodeo_event_game_info.enable_header));
      }
      if (respData.status !== undefined) {
        eventAction.setStatusMsg(respData.status);
      }
    }
    setSelectedPerformance(performance);
    const seen = checkPromoVidSeen(performance);
    // console.log({seen})
    if (!seen) {
      const vid = performance?.sponsor as { file_mime?: string; original?: string } | undefined;
      const type = vid?.file_mime?.substring(0, vid?.file_mime?.indexOf("/"));
      if (type) {
        setPromoType(type);
      }
      if (vid?.original) {
        setUrl(vid.original);
      }
      if (type == "video" || type == "image") {
        setShowVideoModal(true);
      } else {
        changePage(performance);
      }
    } else {
      changePage(performance);
    }
  };

  const changePage = (performance: { id?: number }) => {
    if (!performance?.id) {
      return;
    }
    const performanceId = cryptr.encrypt(performance.id);
    if (responseDetails?.settings?.is_event_prize || responseDetails?.settings?.is_game_prize) {
      eventAction.rodeoEventSettings(responseDetails?.settings || {});
      if (!responseDetails?.settings?.is_event_prize && responseDetails?.settings?.is_game_prize) {
        history.push(`/prize/${eventId}/${performanceId}/${cryptr.encrypt("Game")}`);
      } else {
        history.push(`/prizes/${eventId}/${performanceId}`);
      }
    } else {
      history.push(`/event/${eventId}/${performanceId}`);
    }
  };

  const checkPromoVidSeen = (performance: { id?: number }) => {
    const x = localStorage.getItem("performanceVidSeen_" + String(performance?.id || ''));
    // console.log({x})
    return x === "1";
  };

  const closeVideoModal = () => {
    setTimeout(() => {
      setShowVideoModal(false);
      if (selectedPerformance?.id) {
        localStorage.setItem("performanceVidSeen_" + selectedPerformance.id, "1");
        changePage(selectedPerformance);
      }
    }, 1000);
  };

  useEffect(() => {
    getPerformanceList();
  }, []);

  useEffect(() => {
    if (userDetails || loginReq == 0) {
      // history.push(`/performances/${eventId}`)
    } else {
      history.push(`${URLS.LOGIN}`);
    }
  }, [loginReq]);

  const goToLeaderBoardPage = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    history.push(`/result/${eventId}`);
  };

  const goBack = () => {
    history.goBack();
  };

  useEffect(() => {}, [performanceList]);

  useEffect(() => {
    if (performanceList && socketData && typeof socketData === "object" && "performance" in socketData) {
      const socketPerf = (socketData as { performance?: Record<string, unknown> & { id?: number } }).performance;
      if (socketPerf && Array.isArray(performanceList)) {
        const p = performanceList.map((x) => {
          if (x.id == socketPerf?.id) {
            return socketPerf;
          }
          return x;
        });
        setSocketData(null);
        setPerformanceList(p);
      }
    }
  }, [performanceList, socketData]);

  return (
    <React.Fragment>
      {url && showVideoModal && promoType && (
        <VideoModal onClose={closeVideoModal} url={url} shouldShow={showVideoModal} type={promoType} />
      )}
      <h2 className="top-two-btns has-leaderboard">
        {!localStorage.getItem(INSIDERODEO_EVENT_STORAGE) ? (
          <Link to={URLS.HOME} className="dual-btn">
            Rodeos
          </Link>
        ) : null}

        <Link to="#" className="dual-btn" onClick={(e) => goToLeaderBoardPage(e)}>
          Progress Board
        </Link>
      </h2>
      <hr className="color-white" />
      {progressPercent > 0 && <ProgressBar progressPercent={progressPercent} />}
      <h2 className="page-title text-left py-3">
        <a onClick={goBack} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </a>
        Days
      </h2>
      <ul className="list-style rodeo-inside-list">
        {performanceList && Array.isArray(performanceList) && performanceList.length ? (
          performanceList.map((performance) => (
            <li
              key={performance?.id}
              className={clsx({
                glow: performance?.rp_start_pick,
              })}
            >
              <Link
                to=""
                className={clsx({
                  "ripple-effect not-started-yet d-flex": performance?.status === 0,
                  "ripple-effect on-going-game d-flex": performance?.status === 1,
                  "ripple-effect event-end d-flex": performance?.status === 2,
                })}
                onClick={(e) => goToGameListingPage(e, performance)}
              >
                <span className="event-img">
                  <img
                    src={
                      performance?.avatar?.id && performance.avatar.id !== 0 && performance.avatar.original
                        ? performance.avatar.original
                        : "/images/no-image.png"
                    }
                    alt={`event-${performance?.title || ""}`}
                  />
                </span>
                <span className="event-info">
                  <span className="d-inline-block event-title">{performance?.title || ""}</span>
                </span>
              </Link>
            </li>
          ))
        ) : (
          <div className="no-text text-white text-center">No days available</div>
        )}
      </ul>
      <Sponsor />
    </React.Fragment>
  );
}
